module.exports = __webpack_public_path__ + "static/AHAplaque-22a57ba295ab68f61b631d5611171553.svg";